import { createContext, useContext, useState } from 'react';

import ConfirmModal from '@/components/modal/ConfirmModal';

interface ConfirmContextType {
  showConfirm: (message: string, onConfirm: () => void) => void;
}

const ConfirmContet = createContext<ConfirmContextType | undefined>(undefined);

export const ConfirmProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [message, setMessage] = useState<string>('');
  const [visible, setVisible] = useState<boolean>(false);
  const [confirmAction, setConfirmAction] = useState<() => void>(() => {});

  const showConfirm = (message: string, onConfirm: () => void) => {
    setMessage(message);
    setConfirmAction(() => () => {
      onConfirm();
      setVisible(false);
    });
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <ConfirmContet.Provider value={{ showConfirm }}>
      {children}
      {visible && (
        <ConfirmModal
          message={message}
          onConfirm={confirmAction}
          onCancel={handleCancel}
        />
      )}
    </ConfirmContet.Provider>
  );
};
export const useConfirm = () => {
  const context = useContext(ConfirmContet);
  if (!context)
    throw new Error('useConfirm must be used within an ConfirmProvider');
  return context;
};
